import { useContext } from 'react'

import { TableGridContext } from '@component/Layout/TableGridScroll'

import type { ITableGridContext } from '@base/@types/components/Layout/TableGrid'

export default function useTableScrollProductSimilaruseTableScroll(): ITableGridContext {
  const context = useContext(TableGridContext)

  return context
}
